/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPaperclipIcon20Solid = forwardRef('AttachPaperclipIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.011 3.517a3.987 3.987 0 1 1 5.639 5.638l-7.042 7.042a5.48 5.48 0 1 1-7.75-7.75l4.929-4.93A1 1 0 0 1 9.2 4.93l-4.93 4.93a3.48 3.48 0 1 0 4.923 4.921l7.042-7.041a1.987 1.987 0 1 0-2.81-2.81l-7.042 7.041a.494.494 0 0 0 .698.698l4.93-4.929a1 1 0 1 1 1.413 1.414l-4.929 4.93a2.493 2.493 0 1 1-3.526-3.527l7.042-7.041Z" })));
});
